import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import authService from "./AuthorizeService";

function RequireAuth({ children }: { children: JSX.Element }) {
  const [ready, setReady] = useState<boolean>(false);
  const [authenticated, setAuthenticated] = useState<boolean>(false);
  let location = useLocation();

  useEffect(() => {
    checkAuthStatus();
    authService.subscribe(() => {
      checkAuthStatus();
    });
  }, []);

  const checkAuthStatus = () => {
    authService.isAuthenticated().then((result) => {
      setAuthenticated(result);
      setReady(true);
    });
  };

  if (!ready) {
    return <div></div>;
  } else if (ready && !authenticated) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/account/login" state={{ from: location }} />;
  }

  return children;
}

export default RequireAuth;
